import { timeDay, timeFormat, timeHour, timeMinute, timeMonth, timeWeek, timeYear } from 'd3';

export const formatSecond = timeFormat(':%S');
export const formatMinute = timeFormat('%I:%M');
export const formatHour = timeFormat('%I %p');
export const formatDay = timeFormat('%a %d');
export const formatMonth = timeFormat('%b %d');
export const formatYear = timeFormat('%Y');

export const timeTickFormatFromDomain = ([start, end]: [Date, Date]) => {
  if (timeMinute.count(start, end) <= 1) {
    return formatSecond;
  }

  if (timeHour.count(start, end) <= 1) {
    return formatMinute;
  }

  if (timeDay.count(start, end) <= 1) {
    return formatHour;
  }

  if (timeWeek.count(start, end) <= 1) {
    return formatDay;
  }

  if (timeMonth.count(start, end) <= 1) {
    return formatMonth;
  }

  if (timeYear.count(start, end) <= 1) {
    return formatMonth;
  }

  return formatYear;
};
